<mat-accordion>
  <div class="accordion" [ngClass]="{ 'no-margin': noMargin(), 'first-margin-top': firstMarginTop() }">
    <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
      <mat-expansion-panel-header [ngClass]="{ 'accordion-header-opened-background': panelOpenState() }">
        <mat-panel-title>
          <div class="accordion-header">
              <div class="title-group">
                  <h3 class="admin-text">{{ title() }}</h3>
                  <p class="notification">
                      (Inhalt {{panelOpenState() ? 'ausblenden' : 'einblenden'}})
                  </p> 
              </div> 
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-content></ng-content> 
    </mat-expansion-panel>
  </div>
</mat-accordion>